//=================================\\
// Burger Btn Settings \\
//=================================\\

export default function burgerBtn() {
	let burgerBtn = $('.nav-primary__toggle-btn');
	burgerBtn.on("click", function () {
		let socialLinks = $('.ac-social-links'),
			headerMobile = $('.header___mobile'),
			mobileContainer = $('.nav-primary__mobail-menu-container');

		socialLinks.css('display', 'flex');
		headerMobile.css('display', 'flex');
		mobileContainer.show();

		if (!$(this).hasClass('ac-open')) {
			mobileContainer.hide();
			socialLinks.hide();
			headerMobile.hide();
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/burger-btn.js